<template>
  <div class="product--row">
    <b-row>
      <b-col md="6">
        <b-row>
          <b-col cols="2" md="4" class="text-center">
            <div style="width:100% ;">
              <img
                :src="getImageUrl(prod.Image)"
                alt
                style="object-fit:cover; max-width: 100% ; max-height: 100px ; object-fit: center"
              />
            </div>
          </b-col>
          <b-col cols="6" md="8">
            <h5 class="pt-2">{{ prod.Title }}</h5>
            <h6>{{ prod.UoM }}</h6>
            <h6 class="p-2">AED&nbsp;{{ this.getProdPrice(prod.Price) }}</h6>
          </b-col>
          <b-col cols="4" class="d-md-none">
            <h6 class="p-2">AED&nbsp;{{ totalPrice }}</h6>
            <h6 class="px-2 small-font product-actions">
              <a href="#" @click="removeFromCart">Remove</a>
            </h6>
          </b-col>
        </b-row>
      </b-col>

      <!-- Qty ctrls -->
      <b-col md="4" sm="4">
        <div class="p-2">
          <b-button class="order-btns" size="sm" @click="decrementOrder">
            <font-awesome-icon class="order-icons" icon="minus"></font-awesome-icon>
          </b-button>
          <button class="btn order-btns btn-sm" disabled>{{ prod.orderQty }}</button>
          <b-button class="order-btns" size="sm" @click="incrementOrder">
            <font-awesome-icon class="order-icons" icon="plus"></font-awesome-icon>
          </b-button>
        </div>
      </b-col>

      <!-- Total Price And Extra options -->
      <b-col sm="4" md="2" class="text-right d-none d-md-block">
        <h6 class="p-2">AED&nbsp;{{ totalPrice }}</h6>
        <h6 class="px-2 small-font product-actions">
          <a href="#" @click="removeFromCart">Remove</a>
        </h6>
      </b-col>
    </b-row>
    <hr class="d-none d-md-block" />
  </div>
</template>

<script>
export default {
  name: "ProductRow",
  props: ["prod"],
  computed: {
    totalPrice() {
      return this.getProdPrice(this.prod.Price * this.prod.orderQty);
    },
  },
  methods: {
    incrementOrder() {
      if (this.prod.Avail > 0) {
        this.$store.commit("incrementOrder", this.prod.id);
        this.$store.dispatch("updateShippingCost");
      }
    },
    decrementOrder() {
      if (this.prod.orderQty > 0) {
        this.$store.commit("decrementOrder", this.prod.id);
        this.$store.dispatch("updateShippingCost");
      }
    },
    removeFromCart() {
      this.$store.commit("removeFromCart", this.prod.id);
      this.$store.dispatch("updateShippingCost");
    },
  },
};
</script>

<style scoped>
.order-btns {
  display: inline;
  margin-right: 0.5rem;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 5px;
  padding: 8px 18px;
  opacity: 1 !important;
}

.order-icons {
  color: #000000;
}

div[class*="col"] {
  padding-top: 7px;
}

.small-font {
  font: small-caption;
}

.product-actions a {
  color: black;
  margin: 0;
  margin-bottom: 5px;
  text-decoration-line: underline;
  text-decoration-style: solid;
}

@media screen and (max-width: 768px) {
  .product--row {
    background: white;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 20px;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  }
}
</style>
